import ApplicationsRouter from '@/components/pages/application/index.vue';
import List from '@/components/pages/application/List.vue';
import Add from '@/components/pages/application/Add.vue';
import Detail from '@/components/pages/application/Detail.vue';

export default {
  path: '/applications',
  name: 'ApplicationsRouter',
  component: ApplicationsRouter,
  children: [
    {
      path: '/applications',
      name: 'Applications',
      component: List,
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
    {
      path: '/applications/add',
      name: 'ApplicationAdd',
      component: Add,
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
    {
      path: '/applications/:applicationId',
      name: 'ApplicationDetail',
      component: Detail,
      meta: {
        acceptRoles: ['senior', 'tutor', 'admin'],
      },
    },
  ],
}
